import React from "react";
import { Container, Row, Col, Table, Form, Button, Alert } from "react-bootstrap";
import axios from "axios";
import store from "../components/redux/store";
import MyToast from "./myToast";
import "../asserts/css/style.css";

const getDefaultExamYearMonth = () => {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
};

const getServerIP = () => {
  const dropDown = store.getState().dropDown;
  const base = dropDown && dropDown.length > 0 ? dropDown[dropDown.length - 1] : "/api-backend/";
  return base || "/api-backend/";
};

class AnswerSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serverIP: getServerIP(),
      examYearMonth: getDefaultExamYearMonth(),
      employeeNoCell: "B2",
      employeeNameCell: "B3",
      departmentCell: "",
      answerDateCell: "",
      questions: [{ questionNo: 1, cellAddress: "H10", standardAnswer: "", enabled: "1" }],
      scores: [],
      summary: {},
      files: [],
      errors: [],
      warnings: [],
      nameMismatches: [],
      message: "",
      type: "",
      myToastShow: false,
      loading: false,
      configOpen: false,
      cancelTargetKey: "",
    };
  }

  componentDidMount() {
    this.loadPageData();
  }

  showToast = (message, type) => {
    this.setState({ message, type, myToastShow: true });
    setTimeout(() => this.setState({ myToastShow: false }), 3000);
  };

  loadPageData = () => {
    const { serverIP, examYearMonth } = this.state;
    this.setState({ loading: true });
    axios
      .post(serverIP + "answerSummary/getPageData", { examYearMonth })
      .then((response) => {
        this.applyPageData(response.data);
      })
      .catch((error) => {
        console.error(error);
        this.showToast("読み込みに失敗しました", "error");
      })
      .finally(() => this.setState({ loading: false }));
  };

  applyPageData = (data) => {
    const config = data.config || [];
    // Fixed fields share the same config table as question cells, keyed by itemType.
    const employeeNoConfig = config.find((item) => item.itemType === "EMPLOYEE_NO");
    const employeeNameConfig = config.find((item) => item.itemType === "EMPLOYEE_NAME");
    const departmentConfig = config.find((item) => item.itemType === "DEPARTMENT");
    const answerDateConfig = config.find((item) => item.itemType === "ANSWER_DATE");
    const questions = config
      .filter((item) => item.itemType === "QUESTION")
      .map((item) => ({
        questionNo: item.questionNo,
        cellAddress: item.cellAddress || "",
        standardAnswer: item.standardAnswer || "",
        enabled: item.enabled || "1",
      }));

    this.setState({
      employeeNoCell: employeeNoConfig ? employeeNoConfig.cellAddress : this.state.employeeNoCell,
      employeeNameCell: employeeNameConfig ? employeeNameConfig.cellAddress : this.state.employeeNameCell,
      departmentCell: departmentConfig ? departmentConfig.cellAddress : "",
      answerDateCell: answerDateConfig ? answerDateConfig.cellAddress : "",
      questions: questions.length > 0 ? questions : this.state.questions,
      scores: data.scores || [],
      summary: data.summary || {},
    });
  };

  handleExamChange = (event) => {
    this.setState({ examYearMonth: event.target.value }, this.loadPageData);
  };

  handleQuestionChange = (index, field, value) => {
    const questions = [...this.state.questions];
    questions[index] = { ...questions[index], [field]: value };
    this.setState({ questions });
  };

  addQuestion = () => {
    const questions = [...this.state.questions];
    questions.push({
      questionNo: questions.length + 1,
      cellAddress: "",
      standardAnswer: "",
      enabled: "1",
    });
    this.setState({ questions });
  };

  removeQuestion = (index) => {
    const questions = this.state.questions
      .filter((_, i) => i !== index)
      .map((item, i) => ({ ...item, questionNo: i + 1 }));
    this.setState({ questions });
  };

  saveConfig = () => {
    if (!this.state.employeeNoCell || !this.state.employeeNameCell) {
      this.showToast("社員番号セルと氏名セルを入力してください", "error");
      return;
    }
    const configs = [
      {
        itemType: "EMPLOYEE_NO",
        questionNo: 0,
        cellAddress: this.state.employeeNoCell,
        standardAnswer: "",
        enabled: "1",
      },
      {
        itemType: "EMPLOYEE_NAME",
        questionNo: 0,
        cellAddress: this.state.employeeNameCell,
        standardAnswer: "",
        enabled: "1",
      },
      {
        itemType: "DEPARTMENT",
        questionNo: 0,
        cellAddress: this.state.departmentCell,
        standardAnswer: "",
        enabled: "1",
      },
      {
        itemType: "ANSWER_DATE",
        questionNo: 0,
        cellAddress: this.state.answerDateCell,
        standardAnswer: "",
        enabled: "1",
      },
      ...this.state.questions.map((item, index) => ({
        itemType: "QUESTION",
        questionNo: index + 1,
        cellAddress: item.cellAddress,
        standardAnswer: item.standardAnswer,
        enabled: item.enabled || "1",
      })),
    ];
    axios
      .post(this.state.serverIP + "answerSummary/saveConfig", {
        examYearMonth: this.state.examYearMonth,
        configs,
      })
      .then(() => {
        this.showToast("保存しました", "success");
        this.loadPageData();
      })
      .catch((error) => {
        console.error(error);
        this.showToast("保存に失敗しました", "error");
      });
  };

  handleFileChange = (event) => {
    this.setState({
      files: Array.from(event.target.files || []),
      errors: [],
      warnings: [],
      nameMismatches: [],
    });
  };

  uploadFiles = (confirmNameMismatch = false) => {
    if (!this.state.files || this.state.files.length === 0) {
      this.showToast("Excelファイルを選択してください", "error");
      return;
    }
    const formData = new FormData();
    formData.append("examYearMonth", this.state.examYearMonth);
    formData.append("confirmNameMismatch", confirmNameMismatch);
    // The backend reads answer dates from the configured Excel cell, not from file metadata.
    this.state.files.forEach((file) => formData.append("files", file));

    this.setState({ loading: true });
    axios
      .post(this.state.serverIP + "answerSummary/uploadAnswers", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          errors: data.errors || [],
          warnings: data.warnings || [],
          nameMismatches: data.nameMismatches || [],
          scores: data.scores || [],
          summary: data.summary || {},
        });
        if ((data.nameMismatches || []).length > 0) {
          this.showToast("氏名不一致の確認が必要です", "error");
        } else if ((data.errors || []).length > 0) {
          this.showToast("一部ファイルの取込に失敗しました", "error");
        } else if ((data.warnings || []).length > 0) {
          this.showToast("取込が完了しました（一部警告あり）", "warning");
        } else {
          this.showToast("取込が完了しました", "success");
        }
      })
      .catch((error) => {
        console.error(error);
        this.showToast("取込に失敗しました", "error");
      })
      .finally(() => this.setState({ loading: false }));
  };

  deleteScore = (employeeNo) => {
    axios
      .post(this.state.serverIP + "answerSummary/deleteScore", {
        examYearMonth: this.state.examYearMonth,
        employeeNo,
      })
      .then((response) => {
        this.applyPageData(response.data || {});
        this.setState({ cancelTargetKey: "" });
        this.showToast("受験記録を削除しました", "success");
      })
      .catch((error) => {
        console.error(error);
        this.showToast("受験記録の削除に失敗しました", "error");
      });
  };

  isFinished = (item) => {
    return Number(item.finalCorrectCount) === Number(item.finalTotalCount) && Number(item.finalTotalCount) > 0;
  };

  formatRate = (value) => {
    if (value === null || value === undefined) return "0%";
    return `${value}%`;
  };

  render() {
    const { summary } = this.state;
    return (
      <Container fluid className="pb-4">
        <MyToast
          myToastShow={this.state.myToastShow}
          message={this.state.message}
          type={this.state.type}
        />
        <h2 className="mb-4">解答状況集計</h2>

        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>試験年月</Form.Label>
              <Form.Control type="month" value={this.state.examYearMonth} onChange={this.handleExamChange} />
            </Form.Group>
          </Col>
          <Col md={4}>
            <div className="border p-3 bg-white">
              <div>修了者数</div>
              <h4>{summary.finishedCount || 0}</h4>
            </div>
          </Col>
          <Col md={4}>
            <div className="border p-3 bg-white">
              <div>最終正解率</div>
              <h4>{this.formatRate(summary.finalSuccessRate)}</h4>
            </div>
          </Col>
        </Row>

        <div className="border p-3 mb-3 bg-white">
          <div
            className="d-flex justify-content-between align-items-center"
            onClick={() => this.setState({ configOpen: !this.state.configOpen })}
            style={{ cursor: "pointer" }}
          >
            <h5 className="mb-0">正解の設定</h5>
            <span className="text-muted">{this.state.configOpen ? "閉じる" : "開く"}</span>
          </div>
          {this.state.configOpen ? (
            <div className="mt-3">
              <Row>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      社員番号セル <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      value={this.state.employeeNoCell}
                      onChange={(e) => this.setState({ employeeNoCell: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      氏名セル <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      value={this.state.employeeNameCell}
                      onChange={(e) => this.setState({ employeeNameCell: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>部署セル</Form.Label>
                    <Form.Control
                      value={this.state.departmentCell}
                      onChange={(e) => this.setState({ departmentCell: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>解答日セル</Form.Label>
                    <Form.Control
                      value={this.state.answerDateCell}
                      onChange={(e) => this.setState({ answerDateCell: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Table bordered hover size="sm">
                <thead>
                  <tr>
                    <th style={{ width: 80 }}>問題</th>
                    <th style={{ width: 180 }}>解答セル</th>
                    <th style={{ width: 180 }}>正解</th>
                    <th style={{ width: 100 }}>有効</th>
                    <th style={{ width: 100 }}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.questions.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <Form.Control
                          value={item.cellAddress}
                          onChange={(e) => this.handleQuestionChange(index, "cellAddress", e.target.value)}
                        />
                      </td>
                      <td>
                        <Form.Control
                          value={item.standardAnswer}
                          onChange={(e) => this.handleQuestionChange(index, "standardAnswer", e.target.value)}
                        />
                      </td>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={item.enabled !== "0"}
                          onChange={(e) => this.handleQuestionChange(index, "enabled", e.target.checked ? "1" : "0")}
                        />
                      </td>
                      <td>
                        <Button variant="outline-danger" size="sm" onClick={() => this.removeQuestion(index)}>
                          削除
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Button variant="outline-primary" size="sm" onClick={this.addQuestion} className="mr-2">
                問題追加
              </Button>
              <Button variant="primary" size="sm" onClick={this.saveConfig}>
                設定保存
              </Button>
            </div>
          ) : null}
        </div>

        <div className="border p-3 mb-3 bg-white">
          <h5>解答Excel取込</h5>
          <Form.Group>
            <Form.Label>Excelファイル</Form.Label>
            <Form.Control
              type="file"
              multiple
              accept=".xls,.xlsx"
              onChange={this.handleFileChange}
            />
            <Form.Text className="text-muted">
              {this.state.files.length > 0 ? `${this.state.files.length} 件選択済み` : "未選択"}
            </Form.Text>
          </Form.Group>
          <Button variant="success" size="sm" onClick={() => this.uploadFiles(false)} disabled={this.state.loading}>
            取込
          </Button>
          {this.state.nameMismatches.length > 0 ? (
            <Button variant="warning" size="sm" onClick={() => this.uploadFiles(true)} className="ml-2">
              氏名不一致を確認して取込
            </Button>
          ) : null}
          {this.state.nameMismatches.map((item, index) => (
            <Alert variant="warning" className="mt-2 mb-0" key={index}>
              {item.fileName}：社員番号 {item.employeeNo} の氏名が一致しません。DB「{item.dbName}」 / Excel「{item.excelName}」
            </Alert>
          ))}
          {this.state.errors.map((item, index) => (
            <Alert variant="danger" className="mt-2 mb-0" key={index}>
              {item}
            </Alert>
          ))}
          {(this.state.warnings || []).map((item, index) => (
            <Alert variant="warning" className="mt-2 mb-0" key={index}>
              {item}
            </Alert>
          ))}
        </div>

        <Table bordered hover size="sm" className="bg-white">
          <thead>
            <tr>
              <th>社員番号</th>
              <th>部署</th>
              <th>氏名</th>
              <th>解答日</th>
              <th>正解数</th>
              <th>総問題数</th>
              <th>状態</th>
            </tr>
          </thead>
          <tbody>
            {this.state.scores.map((item) => {
              const rowKey = `${item.examYearMonth}-${item.employeeNo}`;
              const isFinished = this.isFinished(item);
              // Status buttons double as a compact delete affordance after an explicit click.
              const isCancelVisible = this.state.cancelTargetKey === rowKey;
              return (
                <tr key={rowKey}>
                  <td>{item.employeeNo}</td>
                  <td>{item.departmentName}</td>
                  <td>{item.employeeName}</td>
                  <td>{item.finalAnswerTime}</td>
                  <td>{item.finalCorrectCount}</td>
                  <td>{item.finalTotalCount}</td>
                  <td className="text-center">
                    {isCancelVisible ? (
                      <Button variant="outline-danger" size="sm" onClick={() => this.deleteScore(item.employeeNo)}>
                        受験取消
                      </Button>
                    ) : (
                      <Button
                        variant={isFinished ? "success" : "danger"}
                        size="sm"
                        className="font-weight-bold"
                        onClick={() => this.setState({ cancelTargetKey: rowKey })}
                      >
                        {isFinished ? "修了" : "受験中"}
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Container>
    );
  }
}

export default AnswerSummary;
